<template>
  <div class="finance-wrap">
    <!-- 顶部资产概览卡片 -->
    <div class="asset-row">
      <div class="asset-card">
        <div class="asset-label">账户可用余额</div>
        <div class="asset-value">
          ¥{{ walletInfo.available_balance ?? 0 }}
          <div style="font-size: 12px; color: #667999">
            (已冻结¥{{ walletInfo.frozen_amount ?? 0 }})
          </div>
        </div>
      </div>
      <div class="asset-card">
        <div class="asset-label">今日消耗额度</div>
        <div class="asset-value consume">
          ¥{{ walletInfo.day_cost_amount || 0.0 }}
        </div>
      </div>
      <div class="asset-card">
        <div class="asset-label">当月消耗额度</div>
        <div class="asset-value consume">
          ¥{{ walletInfo.month_cost_amount || 0.0 }}
        </div>
      </div>
      <div class="asset-card setting-card">
        <div class="asset-label">预警阈值</div>
        <div class="asset-value warn">
          ¥{{ walletInfo.warning_threshold || 0.0 }}
        </div>
      </div>
    </div>

    <!-- 查询筛选区域 -->
    <div class="curd">
      <div class="search-form">
        <el-form :model="query" inline>
          <el-form-item label="支付渠道">
            <el-select v-model="query.paytype" placeholder="全部渠道" clearable style="width: 160px">
              <el-option label="微信支付" value="WECHAT_PAY" />
              <el-option label="支付宝" value="ALIPAY" />
              <el-option label="对公打款" value="CORPORATE_TRANSFER" />
            </el-select>
          </el-form-item>

          <el-form-item label="支付状态">
            <el-select v-model="query.status" placeholder="全部" clearable style="width: 140px">
              <el-option label="交易完成" value="SUCCESS" />
              <el-option label="待支付" value="PENDING" />
              <el-option label="订单超时关闭" value="TIMEOUT" />
            </el-select>
          </el-form-item>

          <el-form-item label="订单号">
            <el-input v-model="query.orderNo" placeholder="输入订单号搜索" clearable @keyup.enter="handleSearch" />
          </el-form-item>

          <el-form-item label="时间范围">
            <el-date-picker
              v-model="query.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              :shortcuts="dateShortcuts"
              style="width: 260px"
              @change="onDateChange"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="zhu">
      <el-table
        :data="walletLogList.list || []"
        border
        stripe
        class="biao"
        ref="tableRef"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="55" />
        <el-table-column label="订单号" prop="orderNo" align="center" min-width="220" show-overflow-tooltip />
        <el-table-column label="支付渠道" align="center" width="130">
          <template #default="scope">
            <el-tag :type="getPayTypeTag(scope.row.paytype)">
              {{ getPayTypeName(scope.row.paytype) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="充值金额" align="center" width="120">
          <template #default="scope">
            <span class="text-green">+¥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" align="center" width="180">
          <template #default="scope">{{ formatDate(scope.row.create_time) }}</template>
        </el-table-column>
        <el-table-column label="支付时间" prop="pay_time" align="center" width="180">
          <template #default="scope">{{ formatDate(scope.row.pay_time) }}</template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" width="160">
          <template #default="scope">
            <el-tag :type="getStatusTag(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="160">
          <template #default="scope">
            <el-button
              v-if="scope.row.status === 'PENDING'"
              type="primary"
              text
              @click="viewDetail(scope.row)"
            >
              查看待支付信息
            </el-button>
            <span v-else style="color:#999">—</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="page">
      <div style="margin-right: 16px; color: #666" v-if="selectedRows.length > 0">
        已选中
        <span style="color: #2b5bff; font-weight: bold">{{ selectedRows.length }}</span>
        条
      </div>
      <el-pagination
        v-model:current-page="walletLogList.page"
        v-model:page-size="walletLogList.pageSize"
        :total="walletLogList.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSearch"
        @current-change="handleSearch"
      />
    </div>
  </div>

  <!-- 支付弹窗 -->
  <el-dialog
    v-model="tradeDialogVisible"
    title="待支付信息"
    width="480px"
    :close-on-click-modal="false"
    @opened="dialogOpened"
    @close="dialogClosed"
  >
    <div class="pay-qr-content" style="text-align: center; padding: 10px 0">
      <!-- 微信/支付宝二维码 -->
      <div v-if="['WECHAT_PAY', 'ALIPAY'].includes(payInfo.paytype)">
        <div v-if="qrImgSrc">
          <img :src="qrImgSrc" style="width: 200px; height: 200px" alt="支付二维码" />
        </div>
        <div
          v-else
          style="width: 200px;height: 200px;line-height: 200px;margin: 0 auto;background: #f5f5f5;border-radius: 8px;"
        >
          加载中...
        </div>
        <div style="margin-top: 16px; font-size: 14px; color: #666">
          <p>订单号：{{ payInfo.orderNo }}</p>
          <p style="margin-top: 6px">
            充值金额：<span style="color: #de1c2c; font-weight: bold">¥{{ payInfo.amount }}</span>
          </p>
        </div>
        <div style="margin-top: 14px; font-size: 13px; color: #999">
          ⚠️ 请使用对应APP扫码，支付完成页面自动刷新
        </div>
        <el-button size="small" @click="refreshQrCode" style="margin-top: 12px">刷新二维码</el-button>
      </div>

      <!-- ==========【修改后的对公转账区块】========== -->
      <div v-else-if="payInfo.paytype === 'CORPORATE_TRANSFER'" style="text-align:left;">
        <div style="background: #f7f8fa;border-radius: 10px;padding: 18px;">
          <div style="color: #e64340; font-weight: bold; margin-bottom:14px">🏦 对公转账收款账户信息</div>



          <!-- =====方案2：固定静态账户（测试临时使用，注释方案1启用此段）===== -->
          
          <div class="bank-item">
            <label>收款户名：</label>
            <span>爱求索信息技术吉林有限公司</span>
          </div>
          <div class="bank-item">
            <label>开户银行：</label>
            <span>中国建设银行股份有限公司长春高新技术产业开发区支行</span>
          </div>
          <div class="bank-item">
            <label>银行账号：</label>
            <span>2205 0137 0100 0000 3534</span>
          </div>
          

          <el-button size="small" type="primary" plain style="margin-top:12px" @click="copyBankInfo">
            一键复制全部转账信息
          </el-button>
        </div>

        <div style="margin-top: 16px; font-size: 14px; color: #333">
          <p>订单号：{{ payInfo.orderNo }}</p>
          <p style="margin-top: 6px">
            充值金额：<span style="color: #de1c2c; font-weight: bold">¥{{ payInfo.amount }}</span>
          </p>
        </div>
        <div style="margin-top: 14px; font-size: 13px; color: #999;line-height:1.6;">
          ⚠️ <strong>重要提醒：</strong><span style="color: #e64340;font-weight: bold;">转账备注务必填写【公司名称 + 充值金额 + {{ payInfo.orderNo }}】</span>，财务根据订单号匹配账单；
          转账完成等待人工对账审核，对账成功页面自动更新状态。
        </div>
      </div>
    </div>
    <template #footer>
      <el-button @click="tradeDialogVisible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted } from "vue";
import QRCode from "qrcode";
import { ElMessage } from "element-plus";
import { getWalletInfo, getPayOrderList, rechargeStatus } from "@/api/api";

const tableRef = ref(null);
const selectedRows = ref([]);
const walletInfo = ref({});

// 分页数据
const walletLogList = ref({
  list: [],
  page: 1,
  pageSize: 10,
  total: 0,
});

const tradeDialogVisible = ref(false);
const qrImgSrc = ref("");
const payInfo = ref({});

// 轮询配置
let pollTimer = null;
const MAX_POLL_TIMES = 36; // 5秒一次，最多轮询3分钟
let pollCount = 0;

// 查询条件
const query = reactive({
  paytype: "",
  status: "",
  orderNo: "",
  dateRange: [],
  startDate: "",
  endDate: "",
});

const dateShortcuts = [
  {
    text: "今日",
    value: () => {
      const now = new Date();
      return [new Date(now.setHours(0, 0, 0, 0)), new Date()];
    },
  },
  {
    text: "本月",
    value: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      start.setHours(0, 0, 0, 0);
      return [start, new Date()];
    },
  },
];

// 日期组件赋值
const onDateChange = (val) => {
  if (val && val.length === 2) {
    query.startDate = val[0];
    query.endDate = val[1];
  } else {
    query.startDate = "";
    query.endDate = "";
  }
};

// 支付渠道名称映射
const getPayTypeName = (val) => {
  const map = {
    WECHAT_PAY: "微信支付",
    ALIPAY: "支付宝",
    CORPORATE_TRANSFER: "对公打款",
  };
  return map[val] || val;
};
const getPayTypeTag = (val) => {
  const map = {
    WECHAT_PAY: "success",
    ALIPAY: "primary",
    CORPORATE_TRANSFER: "info",
  };
  return map[val] || "info";
};

// 订单状态映射
const getStatusText = (val) => {
  const map = {
    SUCCESS: "交易已完成",
    PENDING: "等待用户付款",
    TIMEOUT: "订单超时关闭",
  };
  return map[val] || val;
};
const getStatusTag = (val) => {
  const map = {
    SUCCESS: "success",
    PENDING: "warning",
    TIMEOUT: "danger",
  };
  return map[val] || "info";
};

// ISO时间格式化
const formatDate = (isoStr) => {
  if (!isoStr) return "-";
  const date = new Date(isoStr);
  return date.toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const handleSelectionChange = (val) => {
  selectedRows.value = val;
};

// 查询列表
const handleSearch = () => {
  selectedRows.value = [];
  tableRef.value?.clearSelection();
  getPayOrderListData();
};

// 重置筛选条件
const resetQuery = () => {
  query.paytype = "";
  query.status = "";
  query.orderNo = "";
  query.dateRange = [];
  query.startDate = "";
  query.endDate = "";
  walletLogList.value.page = 1;
  handleSearch();
};

// 获取账户资产信息
const getAssetInfo = async () => {
  const res = await getWalletInfo();
  if (res.code === 200) {
    walletInfo.value = res.data;
  }
};

// 获取充值订单列表
const getPayOrderListData = async () => {
  const params = {};
  params.page = walletLogList.value.page;
  params.pageSize = walletLogList.value.pageSize;
  if (query.paytype) params.paytype = query.paytype;
  if (query.status) params.status = query.status;
  if (query.orderNo) params.orderNo = query.orderNo;
  if (query.startDate) params.startDate = query.startDate;
  if (query.endDate) params.endDate = query.endDate;

  const res = await getPayOrderList(params);
  if (res.code === 200) {
    walletLogList.value = res.data;
  }
};

// 打开弹窗
const viewDetail = async (row) => {
  payInfo.value = { ...row };
  qrImgSrc.value = "";
  pollCount = 0;
  tradeDialogVisible.value = true;
};

// 弹窗完全打开后执行
const dialogOpened = async () => {
  const row = payInfo.value;
  // 生成二维码
  if (["WECHAT_PAY", "ALIPAY"].includes(row.paytype) && row.pay_url) {
    try {
      const dataUrl = await QRCode.toDataURL(row.pay_url, { width: 200, margin: 2 });
      qrImgSrc.value = dataUrl;
    } catch (err) {
      ElMessage.error("二维码生成失败");
      console.error(err);
    }
  }
  // 启动订单状态轮询
  startPoll();
};

// 启动轮询订单状态
const startPoll = () => {
  clearPollTimer();
  pollTimer = setInterval(async () => {
    pollCount++;
    if (pollCount >= MAX_POLL_TIMES) {
      clearPollTimer();
      ElMessage.warning("查询超时，请关闭弹窗重新打开");
      return;
    }
    await queryOrderStatus();
  }, 5000);
};

// 查询订单状态（对接rechargeStatus）
const queryOrderStatus = async () => {
  try {
    const res = await rechargeStatus({ orderno: payInfo.value.orderNo });
    if (res.code !== 200) return;
    const status = res.data.status;

    if (status === "SUCCESS") {
      ElMessage.success("充值成功！额度已到账");
      clearPollTimer();
      tradeDialogVisible.value = false;
      // 刷新余额 + 账单列表
      getAssetInfo();
      getPayOrderListData();
    } else if (status === "TIMEOUT") {
      ElMessage.warning("订单已超时关闭，请重新发起充值");
      clearPollTimer();
      tradeDialogVisible.value = false;
      getPayOrderListData();
    }
    // PENDING：继续等待，不处理
  } catch (err) {
    console.error("状态查询异常", err);
  }
};

// 刷新二维码
const refreshQrCode = async () => {
  qrImgSrc.value = "";
  const row = payInfo.value;
  if (!row.pay_url) {
    ElMessage.warning("支付链接不存在");
    return;
  }
  try {
    const dataUrl = await QRCode.toDataURL(row.pay_url, { width: 200, margin: 2 });
    qrImgSrc.value = dataUrl;
    ElMessage.success("二维码已刷新");
  } catch (err) {
    ElMessage.error("刷新失败");
  }
};

// 【新增】一键复制对公账户信息
const copyBankInfo = async () => {
  const info = `收款户名：${payInfo.value.bank_user}
开户银行：${payInfo.value.bank_name}
银行账号：${payInfo.value.bank_account}
转账备注：${payInfo.value.orderNo}
转账金额：¥${payInfo.value.amount}`;
  try {
    await navigator.clipboard.writeText(info);
    ElMessage.success("转账信息已复制，可以直接粘贴");
  } catch (e) {
    ElMessage.error("复制失败，请手动复制");
  }
};

// 清除定时器封装
const clearPollTimer = () => {
  if (pollTimer) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
  pollCount = 0;
};

// 弹窗关闭清理
const dialogClosed = () => {
  clearPollTimer();
  qrImgSrc.value = "";
  payInfo.value = {};
};

onMounted(() => {
  getAssetInfo();
  getPayOrderListData();
});

// 组件销毁强制清理定时器，防止内存泄漏
onUnmounted(() => {
  clearPollTimer();
});
</script>

<style lang="scss" scoped>
.finance-wrap {
  width: 100%;
  min-height: 100vh;
  padding: 24px;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  background: radial-gradient(1200px 600px at 10% -10%, #e8efff 0%, transparent 60%),
    radial-gradient(900px 500px at 110% 110%, #f0eaff 0%, transparent 55%),
    linear-gradient(180deg, #f7f9ff 0%, #eef2fb 100%);
  display: flex;
  flex-direction: column;
  gap: 20px;

  .asset-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 16px;
    .asset-card {
      background: #ffffff;
      border-radius: 16px;
      padding: 24px;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
        0 32px 64px -32px rgba(43, 91, 255, 0.18);
      .asset-label {
        font-size: 14px;
        color: #6b7280;
      }
      .asset-value {
        font-size: 26px;
        font-weight: 600;
        color: #111827;
        margin-top: 8px;
      }
    }
  }

  .curd {
    width: 100%;
    background: #fff;
    border-radius: 16px;
    padding: 16px 20px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
      0 32px 64px -32px rgba(43, 91, 255, 0.18);
  }

  .zhu {
    width: 100%;
    flex: 1;
    background: #fff;
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
      0 32px 64px -32px rgba(43, 91, 255, 0.18);
  }

  .page {
    width: 100%;
    height: 48px;
    display: flex;
    padding: 10px 0;
    justify-content: flex-end;
    align-items: center;
  }

  .text-green {
    color: #16a34a;
    font-weight: 500;
  }
}

/* 对公账户信息样式 */
.bank-item {
  display:flex;
  line-height:2.2;
  font-size:14px;
  label{
    width:80px;
    color:#666;
  }
  span{
    flex:1;
    color:#111;
    font-weight:500;
    word-break: break-all;
  }
}

@media (max-width: 720px) {
  .finance-wrap {
    padding: 12px;
  }
  .asset-row {
    grid-template-columns: 1fr;
  }
}
</style>